<template>
	<c-dialog ref="dialog"  mask-close mode="slide" width="800" mask-close>
		<!-- 产品信息头部 -->
		<div class="product-header">
			<h3>{{productInfo.product_name || '-'}}</h3>
			<p v-if="productInfo.produce_imei">IMEI：{{productInfo.produce_imei}}</p>
		</div>

		<c-form ref="form" vertical unit-width="100%">
			<c-form-item label="产品背贴码" required>
				<div class="scan-input-wrap flex-center-cross">
					<c-input
						ref="codeInput"
						v-model="formData.produce_unique_code"
						placeholder="请扫描/输入背贴码"
                        :disabled="editData != null || disabled"
						@keyup.enter.native="scanProduct(false)"
						@blur="scanProduct(true)"
					>
						<template #appendIcon><i class="tf-scan"></i></template>
					</c-input>
				</div>
			</c-form-item>

			<c-form-item label="维修项目（可多选）" required>
				<c-select
					v-model="formData.repair_items"
					:options="repairItemDic"
					multiple
					filterable
					placeholder="请选择"
					@change="onRepairItemChange"
				></c-select>
			</c-form-item>

			<!-- 动态维修金额输入 -->
			<c-form-item
				v-for="item in selectedRepairItems"
				:key="item.value"
				:label="'（' + item.name + '）维修金额'"
				required
			>
				<div class="amount-input-wrap flex-center-cross">
					<c-input
						v-model="formData.amounts[item.value]"
						type="number"
                        decimal="2"
						:range="[-99999999, 99999999]"
						placeholder="请输入维修金额"
						append-text="元"
					></c-input>
				</div>
			</c-form-item>

			<c-form-item label="备注">
				<c-input type="textarea" v-model="formData.remark" placeholder="请输入" maxlength="200"></c-input>
			</c-form-item>
		</c-form>

		<template #button>
			<c-button size="dialog" color="main" @click="submitHandle">确定</c-button>
			<c-button size="dialog" @click="$refs.dialog.close()">取消</c-button>
		</template>
	</c-dialog>
</template>

<script>
export default {
	name: 'repairAddDialog',

	props: {
		// 编辑模式时传入的维修记录数据
		editData: {
			type: Object,
			default: null
		}
	},

	data() {
		return {
			productInfo: {
                product_name: '',
                produce_imei: '',
                product_code_id: '',
                produce_unique_code: ''
            },
			formData: {
				produce_unique_code: '',
                produce_unique_code_id: '',
				repair_items: [],
				amounts: {},
				remark: ''
			},
			lastQueriedCode: '',
			repairItemDic: [],
            disabled: false
		}
	},

	computed: {
		/*********已选维修项列表**********/
		selectedRepairItems() {
			if (!this.repairItemDic || !this.formData.repair_items.length) return [];
			var dicMap = {};
			this.repairItemDic.forEach(function(item) {
				dicMap[item.value] = item;
			});
			return this.formData.repair_items.map(val => {
				var item = dicMap[val];
				return item ? {name: item.name, value: val} : null;
			}).filter(Boolean);
		}
	},

	methods: {
		/*********获取产品信息文字**********/
		getProductText(data) {
			var parts = [];
			if (data.brand_name) parts.push(data.brand_name);
			if (data.model_name) parts.push(data.model_name);
			if (data.color_name) parts.push(data.color_name);
			if (data.memory_name) parts.push(data.memory_name);
			return parts.join(' ') || '-';
		},

		/*********加载维修项字典**********/
		loadRepairItemDic() {
			var self = this;
			this.request({
				url: '/system/dic/options',
				data: {dic_type_code: 'REPAIR_ITEM'},
				success: function(data) {
					self.repairItemDic = data || [];
				}
			});
		},
		/*********打开弹框**********/
		open(data) {
            this.disabled = false
			this.loadRepairItemDic();
			this.productInfo = {
                product_name: '',
                produce_imei: '',
                product_code_id: '',
                produce_unique_code: ''
            };
			this.formData = {
				produce_unique_code: '',
                produce_unique_code_id: '',
				repair_items: [],
				amounts: {},
				remark: ''
			};
			this.lastQueriedCode = '';

			if (this.editData) {
				// 编辑模式：产品信息由调用方传入
				if (data) {
					this.productInfo.product_name = data.product_name || this.getProductText(data);
					this.productInfo.produce_imei = data.produce_imei || '';
				}
				// 加载维修记录详情（含所有明细项）
				this.loadRepairDetail(this.editData.id);
			} else {
                if (data && data.produce_unique_code) {
                    this.formData.produce_unique_code = data.produce_unique_code || '';
                    this.scanProduct(true)
                    this.disabled = true
                }
            }

			this.$refs.dialog.open({title: this.editData ? '编辑维修记录' : '新建维修记录'});
		},

		/*********加载维修记录详情（编辑模式）**********/
		loadRepairDetail(repairId) {
			var self = this;
			this.request({
				url: '/repair/record/detail',
				data: {id: repairId},
				success: function(data) {
					var info = data.info || data;
					var details = data.details || [];
					self.formData.produce_unique_code = info.produce_unique_code || '';
					self.formData.produce_unique_code_id = info.produce_unique_code_id || '';
					self.lastQueriedCode = self.formData.produce_unique_code;
					self.formData.remark = info.remark || '';
					self.productInfo.produce_imei = info.produce_imei || self.productInfo.produce_imei;
					// 填充所有明细项
					self.formData.repair_items = [];
					details.forEach(function(d) {
						self.formData.repair_items.push(d.repair_item);
						self.$set(self.formData.amounts, d.repair_item, d.repair_amount || '');
					});
				}
			});
		},

		/*********扫码/手动输入 查询产品**********/
		// silentWhenEmpty: true=失焦触发（空值静默），false=回车触发（空值提示）
		scanProduct(silentWhenEmpty) {
			var code = (this.formData.produce_unique_code || '').trim();
			if (!code) {
				if (!silentWhenEmpty) {
					this.$message({message: '请输入背贴码', type: 'warn'});
				}
				return;
			}
			// 同一个码不重复查询（避免回车后又失焦导致的重复请求）
			if (code === this.lastQueriedCode && this.formData.produce_unique_code_id) {
				return;
			}
			var self = this;
			this.request({
				url: '/repair/product/queryByCode',
				data: {produce_unique_code: code},
				loading: true,
				success: (data) => {
					self.formData.produce_unique_code_id = data.produce_unique_code_id;
					self.productInfo.product_name = self.getProductText(data);
                    self.productInfo.produce_imei = data.produce_imei || '';
					self.lastQueriedCode = code;
				},
				fail: (msg) => {
					self.$message({message: msg, type: 'warn'});
					// 查询失败：仅清空输入框并重新聚焦（保留上一次成功查询的状态）
					self.formData.produce_unique_code = '';
					self.focusInput();
				}
			});
		},

		/*********聚焦背贴码输入框**********/
		focusInput() {
			this.$nextTick(() => {
				var input = this.$refs.codeInput && this.$refs.codeInput.$el.querySelector('input');
				if (input) input.focus();
			});
		},

		/*********维修项变化时初始化金额**********/
		onRepairItemChange(val) {
			// 为新增的维修项初始化金额字段
			if (val && Array.isArray(val)) {
				val.forEach(itemVal => {
					if (this.formData.amounts[itemVal] === undefined) {
						this.$set(this.formData.amounts, itemVal, '');
					}
				});
			}
		},

		/*********提交**********/
		submitHandle() {
			if (!this.formData.produce_unique_code_id) {
				this.$message({message: '请先扫描或输入产品背贴码', type: 'warn'});
				return;
			}
			if (!this.formData.repair_items.length) {
				this.$message({message: '请选择维修项目', type: 'warn'});
				return;
			}

			// 校验每个维修项的金额
			for (var i = 0; i < this.formData.repair_items.length; i++) {
				var itemVal = this.formData.repair_items[i];
				var amount = this.formData.amounts[itemVal];
				var itemName = itemVal;
				for (var j = 0; j < this.repairItemDic.length; j++) {
					if (this.repairItemDic[j].value === itemVal) {
						itemName = this.repairItemDic[j].name;
						break;
					}
				}
				if (amount === '' || amount === undefined || amount === null) {
					this.$message({message: '请输入（' + itemName + '）的维修金额', type: 'warn'});
					return;
				}
				var amountNum = parseFloat(amount);
				if (isNaN(amountNum) || amountNum === 0) {
					this.$message({message: '（' + itemName + '）的维修金额不能为0', type: 'warn'});
					return;
				}
			}

			this.submitRepair();
		},

		/*********执行提交**********/
		submitRepair() {
			if (this.editData) {
				// 编辑模式：整体替换维修记录
				var items = this.formData.repair_items.map(function(itemVal) {
					return {repair_item: itemVal, repair_amount: this.formData.amounts[itemVal]};
				}.bind(this));

				this.request({
					url: '/repair/record/edit',
					data: {
						id: this.editData.id,
						items: JSON.stringify(items),
						remark: this.formData.remark
					},
					loading: true,
					success: () => {
						this.$message({message: '保存成功', type: 'success'});
						this.$emit('resolve');
						this.$refs.dialog.close();
					},
					fail: (msg) => {
						this.$message({message: msg, type: 'error'});
					}
				});
			} else {
				// 新建模式：批量添加维修项目
				var items = this.formData.repair_items.map(function(itemVal) {
					return {repair_item: itemVal, repair_amount: this.formData.amounts[itemVal]};
				}.bind(this));

				this.request({
					url: '/repair/record/batchAdd',
					data: {
						produce_unique_code_id: this.formData.produce_unique_code_id,
						items: JSON.stringify(items),
						remark: this.formData.remark
					},
					loading: true,
					success: () => {
						this.$message({message: '保存成功', type: 'success'});
						this.$emit('resolve');
						this.$refs.dialog.close();
					},
					fail: (msg) => {
						this.$message({message: msg, type: 'error'});
					}
				});
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
.product-header
	text-align center
	padding 0 0 12px
	background-color #F0F3FF
	h3
		font-size 18px
		font-weight 600
		color #3D5EFF
		line-height 46px
	p
		margin 0
		font-size 13px
		color #999

.scan-input-wrap
	gap 8px
	>>> .c-input
		flex-grow 1

.amount-input-wrap
	gap 8px
	>>> .c-input
		flex-grow 1
	.amount-unit
		flex-shrink 0
		font-size 14px
		color #666
</style>
